import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ThirdPartyCostPayment\GetInvoiceItemsByThirdPartyCostPaymentIdController::__invoke
* @see app/Http/Controllers/ThirdPartyCostPayment/GetInvoiceItemsByThirdPartyCostPaymentIdController.php
* @route '/api/third-party-cost-payment/{thirdPartyCostPayment}/paid-invoice-items'
*/
const GetInvoiceItemsByThirdPartyCostPaymentIdController = (args: { thirdPartyCostPayment: string | number | { id: string | number } } | [thirdPartyCostPayment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoiceItemsByThirdPartyCostPaymentIdController.url(args, options),
    method: 'get',
})

GetInvoiceItemsByThirdPartyCostPaymentIdController.definition = {
    methods: ["get","head"],
    url: '/api/third-party-cost-payment/{thirdPartyCostPayment}/paid-invoice-items',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ThirdPartyCostPayment\GetInvoiceItemsByThirdPartyCostPaymentIdController::__invoke
* @see app/Http/Controllers/ThirdPartyCostPayment/GetInvoiceItemsByThirdPartyCostPaymentIdController.php
* @route '/api/third-party-cost-payment/{thirdPartyCostPayment}/paid-invoice-items'
*/
GetInvoiceItemsByThirdPartyCostPaymentIdController.url = (args: { thirdPartyCostPayment: string | number | { id: string | number } } | [thirdPartyCostPayment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { thirdPartyCostPayment: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { thirdPartyCostPayment: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            thirdPartyCostPayment: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        thirdPartyCostPayment: typeof args.thirdPartyCostPayment === 'object'
        ? args.thirdPartyCostPayment.id
        : args.thirdPartyCostPayment,
    }

    return GetInvoiceItemsByThirdPartyCostPaymentIdController.definition.url
            .replace('{thirdPartyCostPayment}', parsedArgs.thirdPartyCostPayment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ThirdPartyCostPayment\GetInvoiceItemsByThirdPartyCostPaymentIdController::__invoke
* @see app/Http/Controllers/ThirdPartyCostPayment/GetInvoiceItemsByThirdPartyCostPaymentIdController.php
* @route '/api/third-party-cost-payment/{thirdPartyCostPayment}/paid-invoice-items'
*/
GetInvoiceItemsByThirdPartyCostPaymentIdController.get = (args: { thirdPartyCostPayment: string | number | { id: string | number } } | [thirdPartyCostPayment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoiceItemsByThirdPartyCostPaymentIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ThirdPartyCostPayment\GetInvoiceItemsByThirdPartyCostPaymentIdController::__invoke
* @see app/Http/Controllers/ThirdPartyCostPayment/GetInvoiceItemsByThirdPartyCostPaymentIdController.php
* @route '/api/third-party-cost-payment/{thirdPartyCostPayment}/paid-invoice-items'
*/
GetInvoiceItemsByThirdPartyCostPaymentIdController.head = (args: { thirdPartyCostPayment: string | number | { id: string | number } } | [thirdPartyCostPayment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetInvoiceItemsByThirdPartyCostPaymentIdController.url(args, options),
    method: 'head',
})

export default GetInvoiceItemsByThirdPartyCostPaymentIdController